import React, { Suspense } from "react";

export class OrbitSuspense extends React.PureComponent {
    render() {
        return <Suspense fallback={<div className="lazy-content"></div>}>
            {this.props.children}
        </Suspense>
    }
}
